import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>隐私协议</h2>
            <h2>Dreamehome隐私政策</h2>
            <h3>引言</h3>
            <p>
                “Dreamehome”业务是由追觅创新科技（苏州）有限公司、及其关联公司（以下称“我们”或“追觅”）运营的，为您提供智能硬件设备控制和管理服务的平台（或服务）。我们理解并清楚个人信息对您的重要性，并将尽全力保护您的个人信息安全。我们将按业界公认的安全标准，采取相应的安全保护措施来保护您的个人信息。
            </p>
            <p>因此，请您在使用我们的产品（或服务）前，仔细阅读并了解本《Dreamehome隐私政策》。</p>
            <p>如您是未成年人，请在监护人同意的情况下使用本应用并同意相关应用服务条款。</p>
            <p>
                本隐私政策在制定时充分考虑到您的需求，您全面了解我们的个人信息收集和使用惯例，同时确保您最终能控制提供给我们的个人信息，这一点至关重要。本隐私政策规定我们如何收集、使用、披露、处理和存储您使用我们的App时提供给我们的信息。我们将严格遵守本隐私政策来使用这些信息。
            </p>
            <p>本隐私政策将帮助您了解以下内容：</p>
            <p>1、我们收集哪些信息以及如何使用信息</p>
            <p>2、我们如何使用 Cookie 和同类技术</p>
            <p>3、我们如何委托处理、共享、转让和公开披露您的个人信息</p>
            <p>4、我们如何存储和保护您的个人信息</p>
            <p>5、您的权利</p>
            <p>6、数据跨境传输</p>
            <p>7、联系我们</p>
            <p>8、本隐私政策如何更新</p>
            <p>附表一：第三方SDK详情</p>
            <p>
                最后，我们的目的是给予您最好的用户体验，如您对本隐私政策存在任何疑问，我们设立了专门的隐私处理部门和人员，您可以通过本隐私政策第七部分与之取得联系。我们将根据各国政策和法律规定的时间来给予回复。如您不满意我们的回复，特别是当您认为我们的个人信息处理行为损害了您的合法权益时，您还可以通过向有管辖权的法院提起诉讼、向政府监管机构投诉等外部途径进行解决。
            </p>
            <h3>一、我们收集哪些信息以及如何使用信息</h3>
            <p>个人信息是指以电子或者其他方式记录的能够通过信息本身或通过关联其他信息后能够识别特定个人的各种数据。</p>
            <p>
                个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全、极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。包括但不限于身份证号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。
            </p>
            <p>我们收集个人信息的主要目的在于向您提供产品和/或服务，并且保证我们遵守适用的相关法律、法规及其他规范性文件。您有权自行选择是否提供该信息，但多数情况下，如果您不提供，我们可能无法向您提供相应的服务，也无法回应您遇到的问题。
            </p>
            <h4>（一）Dreamehome基础服务收集和处理您个人信息的情形</h4>
            <h4>（1） Dreamehome应用对智能硬件设备连接和管理</h4>
            <p>
                为了给您提供Dreamehome的服务，使您可以安全地连接、管理智能硬件设备，我们可能会收集您的Wi-Fi信息、位置信息、登录账号信息、手机相关信息、智能硬件设备相关信息，以及追觅账号和智能硬件设备的关联信息。这些信息将用于为您提供智能硬件设备快连、连接、发现附近设备和设备管理的功能。上述各项信息，详细列举如下：
            </p>
            <p>
                登录账号信息：您的追觅账号用户名、密码、昵称、头像、邮箱、手机号。其中<strong>用户名、密码、手机号、邮箱属于个人敏感信息</strong>，收集此类信息的目的是登录追觅账号服务器认证用户身份，获取Dreamehome账号访问服务器的权限。您输入的账号用户名和登录密码认证信息将会加密传输到追觅账号服务器进行登录认证。
            </p>
            <p>手机相关信息：硬件设备标识(IMEI/OAID, Mac地址, Android
                ID)、手机型号、系统版本信息、系统语言、手机所设置的国家或地区、手机屏幕尺寸及分辨率、CPU及显示设备相关信息。收集此类信息的目的是为了使Dreamehome应用能够连接智能硬件设备。</p>
            <p>
                智能硬件设备的信息：智能硬件设备的名称、型号、版本、生产厂家、设备标识符、MAC地址、IP地址、设备运行状态、自定义属性、设置参数、业务事件和设备控制及使用记录。我们收集此类信息的目的是绑定智能硬件设备，对设备进行控制和管理，以及设置设备属性和参数，查看设备工作状态和历史记录。
            </p>
            <h4>（2） Dreamehome应用和智能硬件设备的升级：</h4>
            <p>
                为了使您持续享受最新的Dreamehome的服务，我们可能会使用您Dreamehome应用的版本信息、手机型号用于为您提供Dreamehome应用的升级服务。同时，我们可能收集您已连接的智能硬件设备列表和版本号信息，用于为您提供智能硬件设备的升级功能，以确保您可以使用最新版本的服务（包括固件版本）。Dreamehome只提供智能硬件设备的升级途径，智能硬件设备固件版本由智能硬件设备的生产厂商提供，生产厂商对版本质量和升级结果负责。
            </p>
            <p>若您不提供这类信息，将无法升级Dreamehome应用和智能硬件设备固件的新版本。</p>
            <h4>（3）在线问题反馈：</h4>
            <p>
                为了帮助您更有效的解决Dreamehome应用、智能硬件设备可能出现的问题，我们提供给您在线问题反馈的渠道，为了实现上述功能，我们需要收集您的以下信息：Dreamehome应用和设备的日志信息、您反馈的联系方式和问题描述、问题现象图片及视频。其中应用和设备的日志信息中会包含设备状态、传感器设备感知到的信息、设备操作记录、设备标识符等，收集此类信息的目的是分析和定位问题原因；收集您的联系方式的目的是为了跟踪回访，了解问题是否完全解决，或者与您联系，希望您补充必要的其他信息。
            </p>
            <p>我们将按照以下方式使用您的个人信息：仅用于反馈问题的定位与解决，不用于个人信息的展示，不将此类信息用于推送商业广告。若您不提供这类信息，将无法对您反馈的问题进行有效的定位和解决。</p>
            <h4>（二）我们在为您提供Dreamehome基础服务以外的收集和处理您个人信息的情形</h4>
            <p>
                Dreamehome除基础服务会使用到您的个人信息以外，我们的以下附加功能中也可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以使用Dreamehome的基础服务，但您可能无法使用这些可以为您所带来便利的附加功能。这些附加功能包括：
            </p>
            <h4>用户体验改进计划：</h4>
            <p>为改进用户体验，我们需要收集您的以下信息：Dreamehome的日志，其中包含经过加密处理后的关键流程日志、事件日志、故障日志、业务事件、App各个界面的使用情况等，日志中不会记录您的敏感信息。</p>
            <p>我们将按照以下方式使用您的个人信息：自动采集上述信息并上传到服务器，分析日志信息诊断设备运行状态并分析App使用情况。</p>
            <p>如果您不提供这些信息，Dreamehome将无法及时改进您的用户体验，但这并不会影响使用本服务的基本功能。</p>
            <h4>（三）我们从第三方获得您个人信息的情形</h4>
            <p>在一些法律允许的情况下，我们可能从第三方处获得您的个人信息。例如：</p>
            <p>1、在您授权的前提下，在第三方智能硬件设备管理业务中，我们将与第三方服务提供商进行合作，其中涉及我们从第三方服务提供商处获取您的个人信息。在第三方设备管理业务中，我们将在您绑定第三方账号的条件下获取您的以下个人信息：</p>
            <p>第三方账号的信息，包括您的昵称、头像，用于在Dreamehome应用中显示；</p>
            <p>设备及网络信息，包括设备标识符、MAC地址、设备序列号，用于识别当前所工作的设备以及进行设备安全控制。</p>
            <p>
                如我们在开展业务时需进行的个人信息处理活动超出您原本向第三方服务提供商提供个人信息时的授权同意范围，我们将在处理您的该等个人信息前，征得您的明示同意。此外，我们也将会严格遵守相关法律法规的规定，并要求第三方服务提供商保障其提供的信息的合法性。
            </p>
            <h4>（四）非个人信息</h4>
            <p>
                我们还可能收集其他无法识别到特定个人的信息（即不属于个人信息的信息），例如您使用特定服务时产生的统计类数据，如用户的操作行为（包括点击、页面跳转、浏览时间）。收集此类信息的目的在于改善我们向您提供的服务。所收集信息的类别和数量取决于您如何使用我们产品和/或服务。
                我们会将此类信息汇总，用于帮助我们向客户提供更有用的信息，了解客户对我们网站、产品和服务中的哪些部分最感兴趣，以便我们优化我们的服务界面。就本隐私政策而言，汇总数据被视为非个人信息。如果我们将非个人信息与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。
            </p>
            <h4>（五）我们调用的系统权限与使用功能说明</h4>
            <p>
                为了产品功能实现与安全稳定运行目的，我们可能会申请或使用操作系统的相关权限。如果您不允许我们调用这些权限，不会影响您使用我们的基本服务功能（基本业务功能所依赖的必要操作系统权限除外），但您可能无法获得这些附加服务给您带来的用户体验。您可在您的设备设置中逐项查看权限的状态，并可决定这些权限随时的开启或关闭。请您注意，以上权限默认关闭状态，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
            </p>
            <p>根据产品的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整，以确保您及时获悉权限的申请与使用情况。</p>
            <p>为保障您的知情权，我们通过下列列表将产品可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理。</p>
            <p>安卓版本会获取的应用权限列表：</p>
            <div className='tableStyle'>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <p>权限名称</p>
                            </td>
                            <td>
                                <p>权限功能说明</p>
                            </td>
                            <td>
                                <p>使用场景或目的</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>拍摄</p>
                            </td>
                            <td>
                                <p>使用拍摄照片</p>
                            </td>
                            <td>
                                <p>用于账号头像的拍摄；用于带音视频功能的扫地设备的音视频通话功能；用于售后服务功能用户反馈信息的上传。</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>访问精准定位</p>
                            </td>
                            <td>
                                <p>通过全球定位系统（GPS）或网络位置信息（例如基站和WLAN）获取精准地理位置信息</p>
                            </td>
                            <td>
                                <p>产品配网过程，用于发现附近的适配扫地机。</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>录音</p>
                            </td>
                            <td>
                                <p>使用麦克风录制音频</p>
                            </td>
                            <td>
                                <p>用于带音视频功能的扫地设备的音视频通话功能；用于售后服务功能用户反馈信息的上传。</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>读取电话状态</p>
                            </td>
                            <td>
                                <p>提供读取手机设备标识等信息，请您放心该权限无法监听、获取您的任何通话内容与信息</p>
                            </td>
                            <td>
                                <p>读取设备识别码，识别手机设备ID，用于精准推送设备状态。</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>读取外置存储器</p>
                            </td>
                            <td>
                                <p>提供读取手机储存空间内数据的功能</p>
                            </td>
                            <td>
                                <p>允许App读取存储中的图片文件，用于设置账号头像；用于售后服务功能用户反馈信息的上传</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>写入外置存储器</p>
                            </td>
                            <td>
                                <p>提供写入外部储存功能</p>
                            </td>
                            <td>
                                <p>允许App写入/下载/保存/修改/删除图片、文件、崩溃日志等信息。</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h3>二、我们如何使用 Cookie 和同类技术</h3>
            <p>为确保Dreamehome的正常运转，我们会在您的设备上存储名为 Cookie 的小数据文件。Cookie
                通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，Dreamehome能够存储您的网站登录账号、偏好等数据。
            </p>
            <p>我们不会将 Cookie 用于本声明所述目的之外的任何用途。您可根据自己的偏好管理或删除
                Cookie。但如果您这么做，在某些情况下可能会影响您安全访问Dreamehome，且可能在每一次访问Dreamehome时都需亲自更改用户设置。</p>
            <h3>三、我们如何委托处理、共享、转让和公开披露您的个人信息？</h3>
            <h4>（一）委托处理</h4>
            <p>在一般情况下，追觅可能会委托其他公司代表我们处理您的个人信息。例如代表我们与您联系、发送电子邮件或者为您提供技术支持的公司，这些公司只能将您的个人信息用于代表我们向您提供服务。</p>
            <p>我们会与被委托方签署严格的保密协议或个人信息处理条款，要求他们按照本隐私政策以及采取相关的保密和安全措施来处理个人信息。</p>
            <h4>（二）共享</h4>
            <p>一般情况下，我们不会对外共享您的个人信息，但以下情况除外：</p>
            <p>1、获得您的明确同意后，我们会向您指定的第三方共享您授权范围内的信息；包括应您的请求，将您的智能家居产品的信息和配置等内容共享给您的亲友，以帮助您的亲友快速通过他们的终端设备使用本软件及服务。</p>
            <p>
                2、Dreamehome服务中部分服务内容由第三方服务提供商提供，为此我们需要向第三方服务提供商提供您的部分个人信息，例如网站托管、数据分析、支付和信用卡处理、基础设施供应、IT服务、客户支持服务、电子邮件发送服务以及其他类似服务，从而确保他们能够为我们提供服务。
            </p>
            <p>3、向直接或间接为您提供智能硬件设备和/或您用来访问和使用我们网站和服务的网络和系统的客户以及其他业务合作伙伴披露您的个人信息。</p>
            <p>
                4、当发生重组、合并、出售、合资、让渡、转让或其他处置我们所有或部分业务、资产或股票（包括但不限于与任何破产或类似程序相关的上述情况）的情况时，向附属公司或其他第三方披露您的个人信息。在这种情况下，您将通过电子邮件和/或我们的网站收到关于所有权变更、个人信息新的使用方式不兼容以及有关个人信息选择的明确通知。
            </p>
            <p>
                5、在我们认为必要或适当的情况下：（a）遵守适用的法律法规；（b）遵守法律程序；（c）响应公共机构和政府当局的要求，包括您居住的国家/地区以外的公共机构和政府当局；（d）履行我们的条款和条件；（e）保护我们的运营、业务和系统；（f）保护我们和/或包括您在内的其他用户的权利、隐私、安全或财产；以及（g）寻求可用的补救措施或限制我们可能需要提供的损害赔偿。
            </p>
            <p>6、向公司旗下的子公司或附属公司披露您的个人信息，以定期开展业务活动。</p>
            <p>7、
                我们会通过应用程序接口（API）、软件工具开发包（SDK）与第三方进行必要的数据共享，不同版本的第三方SDK会有所不同，一般包括第三方账号登录类、分享类、第三方支付类、厂商推送类、统计类等，我们会对第三方进行严格的安全检测并约定数据保护措施。附件一为我们授权接入的第三方SDK详情，请仔细阅读。我们的隐私政策不适用于第三方提供的产品或服务。当您使用这些产品或服务时，也可能收集您的信息。因此，我们强烈建议您花时间阅读该第三方的隐私政策，就像阅读我们的政策一样。我们不对第三方如何使用他们向您收集的个人信息负责，也不能控制其使用。我们的隐私政策不适用通过我们的服务链接的其他网站。您需自行独立判断您与链接网站的互动行为。在您首次进入第三方页面前，第三方服务提供商会向您展示相关的协议和隐私声明，请您仔细阅读这些协议和隐私声明。
            </p>
            <h4>（三）转让</h4>
            <p>追觅不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
            <p>1. 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
            <p>2. 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本声明的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
            <h4>（四）公开披露</h4>
            <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
            <p>1、获得您明确同意后；</p>
            <p>2、基于法律的披露：在符合法律或基于法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
            <h3>四、我们如何存储和保护您的个人信息 </h3>
            <p>
                我们基于本隐私政策中所述的信息收集的目的所必需的期间，或者遵守适用的相关法律要求保留个人信息。个人信息在完成收集目的，或在我们确认您的删除或注销申请后，或我们终止运营相应产品或服务后，我们将停止保留，并做删除或匿名化处理。如果是出于公众利益、科学、历史研究或统计的目的，我们将基于适用的法律继续保留相关数据，即使进一步的数据处理与原有的收集目的无关。
            </p>
            <p>在Dreamehome业务中，您的个人数据具体留存时间如下：</p>
            <p>对于存储在Dreamehome应用本地的数据，当您卸载Dreamehome应用或者清除Dreamehome应用数据时，所有存储的数据将会被立即删除。</p>
            <p>对于存储在服务器上的Dreamehome智能硬件设备和业务数据，当您删除智能硬件设备、拒绝同意Dreamehome隐私政策并停止使用Dreamehome服务时，所有存储的数据将会被立即删除。</p>
            <p>对于存储在服务器上的业务日志、统计数据和历史记录，我们会在不定期清理服务器数据时删除，数据保存时间通常不长于2年。</p>
            <p>此外，当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</p>
            <h3>五、您的权利</h3>
            <h4>（一）访问、更正、删除您的个人信息</h4>
            <p>根据您所适用的国家或地区法律法规，您有权要求访问、更正、删除我们持有的与您相关的任何个人信息（以下简称请求）。请致信或者通过访问Dreamehome联系我们。
                大多数法律要求个人信息主体提出的请求应遵循特定要求，本隐私政策要求您的请求应当符合以下情形：</p>
            <p>通过我们专门的请求渠道，并且出于保护您的信息安全的考虑，您的请求应当是书面的（除非当地法律明确承认口头申请）；</p>
            <p>提供足够的信息使我们可以验证您的身份，确保请求人是所请求信息主体本人或合法授权人；</p>
            <p>一旦我们获得充分信息确认可处理您的请求时，我们将在适用数据保护法律规定的时间内对您的请求做出回应。具体而言：</p>
            <p>基于您的要求及适用法律规定，我们可免费提供一份我们已收集并处理的关于您的个人信息记录， 如您提出对于相关信息的其他请求，我们可能会基于相关适用法律，并结合实际的管理成本向您收取一笔合理的费用。</p>
            <p>如果您认为我们持有的关于您的任何信息是不正确或不完整的，可要求基于使用目的更正或完善个人信息。</p>
            <p>
                根据您适用的法律法规，您可能有权要求我们删除您的个人数据。我们将会根据您的删除请求进行评估，若满足相应规定，我们将会采取包括技术手段在内的相应步骤进行处理。当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。例如，根据《中华人民共和国电子商务法》，您的商品和服务信息、交易信息保存时间自交易完成之日起不得少于三年。
            </p>
            <p>
                我们有权拒绝处理无实质意义/纠缠式重复的请求、损害他人隐私权的请求、极端不现实的请求，要求不相称的技术工作，以及根据当地法律无需给予的请求，已经公之于众的信息，保密条件下给出的信息。如果我们认为删除数据或访问数据的请求的某些方面可能会导致我们无法出于前述反欺诈和安全目的合法使用数据，可能也会予以拒绝。
            </p>
            <h4>（二）撤销同意</h4>
            <p>
                您可以通过提交请求撤销同意，包括收集、使用和/或披露我们掌握或控制的您的个人信息。根据您所使用的具体服务，可以通过本隐私政策第七节中的联系方式联系我们进行相关操作。我们将会在您做出请求后的合理时间内处理您的请求，并且会根据您的请求，在此后不再收集、使用和/或披露您的个人信息。
            </p>
            <p>请注意，根据您授权我们处理信息的范围，您撤销同意可能导致您不能享受Dreamehome或其智能硬件产品的服务。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
            <p>您可以访问通过请求撤销同意或进入Dreamehome页面进行更改以退出用户体验改进计划，撤回对此项个人信息使用的同意。</p>
            <h4>（三）注销Dreamehome账号</h4>
            <p>
                您可以通过访问“我的”——“账号设置”——“删除账号”进行注销Dreamehome账号。如您希望注销Dreamehome账号，由于注销Dreamehome账号的操作将使您无法使用Dreamehome及其全线智能硬件产品和服务，请您谨慎操作。我们为了保护您或他人的合法权益会结合您对Dreamehome各智能硬件产品和服务的使用情况判断是否支持您的注销请求。
            </p>
            <h3>六、数据跨境传输</h3>
            <p>
                由于我们通过遍布全球的资源和服务器提供产品或服务，这意味着，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。您的信息可能传输到的国家/地区的数据保护措施和其他法律可能不像您所在国家/地区那样全面。在此类情况下，我们将根据各个管辖区的适用法律采取适当以及合法的措施，以确保您的个人信息继续受到保护。
            </p>
            <p>特别说明：</p>
            <p>如果您是欧洲经济区 (EEA) 居民，且您的个人信息在 EEA
                境外传输，我们将：在欧盟委员会已确定可以提供足够保护等级的区域处理您的个人信息；或者实施适当的防护措施来保护您的个人信息，包括按照适用的传输机制进行传输，例如欧盟委员会的标准合约条款。</p>
            <h3>七、联系我们</h3>
            <p>
                如果您对本隐私政策有任何意见或问题，或者您对我们收集、使用或披露您的个人信息有任何问题，请通过下方地址或通过访问“我的”——“关注与反馈”联系我们，并提及“隐私政策”。针对您关于个人信息相关的权利请求、问题咨询等时，我们有专业的团队解决你的问题。如果你的问题本身涉及比较重大的事项，我们可能会要求你提供更多信息。如果您对收到的答复不满意，您可以将投诉移交给所在司法辖区的相关监管机构。如果您咨询我们，我们会根据您的实际情况，提供可能适用的相关投诉途径的信息。
            </p>
            <p><strong>邮箱地址：</strong></p>
            <ul>
                <li>中国区联系方式：<a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a> </li>
                <li>新加坡DPO联系方式：<a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                <li>欧盟代表联系方式：<a className="page"
                    href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
            </ul>
            <p><strong>联系电话：</strong>400-875-9511</p>
            <p><strong>网址：</strong><a className="page"
                href="https://www.dreame-technology.com">https://www.dreame-technology.com</a> </p>
            <h3>八、本隐私政策如何更新</h3>
            <p>追觅保留适时更新本政策的权利，当政策发生变更时，我们会通过弹窗方式或其他显著的方式向您展示变更后的政策。只有在获取您的同意后，我们才会按照更新后的政策收集、使用和存储您的个人信息。</p>
            <p>本政策自更新之日起生效。</p>
            <p>最近更新日期：2021年8月28日</p>
            <p><strong>附表一：第三方SDK详情</strong></p>
            <p>*为了给您提供更专业、安全的基础和附加功能服务，Dreamehome会接入第三方SDK产品。目前Dreamehome中存在的第三方SDK产品披露如下：</p>
            <div className='tableStyle'>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <p>SDK服务</p>
                            </td>
                            <td>
                                <p>具体功能</p>
                            </td>
                            <td>
                                <p>获取信息</p>
                            </td>
                            <td>
                                <p>第三方隐私政策</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>友盟统计分析SDK</p>
                            </td>
                            <td>
                                <p>统计分析</p>
                            </td>
                            <td>
                                <p>设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息)、地理位置</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>友盟消息推送SDK</p>
                            </td>
                            <td>
                                <p>消息推送</p>
                            </td>
                            <td>
                                <p>设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息)、地理位置</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>友盟社会化分享SDK</p>
                            </td>
                            <td>
                                <p>第三方分享</p>
                            </td>
                            <td>
                                <p>设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息)、地理位置</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>Agora SDK</p>
                            </td>
                            <td>
                                <p>连麦、视频流播放</p>
                            </td>
                            <td>
                                <p>设备信息、网络状态、相机、麦克风、读写存储空间</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>华为推送SDK</p>
                            </td>
                            <td>
                                <p>推送</p>
                            </td>
                            <td>
                                <p>设备标识信息</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>小米推送SDK</p>
                            </td>
                            <td>
                                <p>推送</p>
                            </td>
                            <td>
                                <p>设备标识信息、设备型号、网络类型、设备存储、设备运行进程信息、应用版本、SDK版本</p>
                            </td>
                            <td>
                                <p>
                                    <p><a className="page"
                                        href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                                    </p>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>OPPO推送SDK</p>
                            </td>
                            <td>
                                <p>推送</p>
                            </td>
                            <td>
                                <p>设备标识信息</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>VIVO推送SDK</p>
                            </td>
                            <td>
                                <p>推送</p>
                            </td>
                            <td>
                                <p>设备标识信息</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>微信SDK</p>
                            </td>
                            <td>
                                <p>微信第三方登录、微信分享</p>
                            </td>
                            <td>
                                <p>设备标识信息、网络信息</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>QQ SDK</p>
                            </td>
                            <td>
                                <p>分享</p>
                            </td>
                            <td>
                                <p>设备标识信息、网络信息</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>微博SDK</p>
                            </td>
                            <td>
                                <p>微博第三方登录、微博分享</p>
                            </td>
                            <td>
                                <p>设备标识信息、网络信息</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>AppleID SDK</p>
                            </td>
                            <td>
                                <p>使用Apple ID登录</p>
                            </td>
                            <td>
                                <p>Apple ID</p>
                            </td>
                            <td>
                                <p><a className="page"
                                    href="https://www.Apple.com/legal/privacy/szh/">https://www.Apple.com/legal/privacy/szh/</a></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>阿里云HTTPDNS SDK</p>
                            </td>
                            <td>
                                <p>优化消息推送网络性能</p>
                            </td>
                            <td>
                                <p>IP地址</p>
                            </td>
                            <td>
                                <p>
                                    <a className="page"
                                        href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202108111133_15842.html?spm=a2c4g.11186623.0.0.9ae430e5ySBBwr">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202108111133_15842.html?spm=a2c4g.11186623.0.0.9ae430e5ySBBwr</a>
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='height'></div>
        </div>
    )
}

export default PricacyPolicy